// Traduction française pour le composant CronLight / CronCore (@vue-js-cron)
// Le paquet ne fournit que la locale "en" dans le bundle réellement chargé
// par notre build webpack (core.esm.js), on fournit donc notre propre
// custom-locale suivant le schéma eachPeriod/eachField attendu.

export const cron_periods_fr = [
	{ id: "minute", text: "minute", value: [] },
	{ id: "hour", text: "heure", value: ["minute"] },
	{ id: "day", text: "jour", value: ["hour", "minute"] },
	{ id: "week", text: "semaine", value: ["dayOfWeek", "hour", "minute"] },
	{ id: "month", text: "mois", value: ["day", "dayOfWeek", "hour", "minute"] },
	{ id: "year", text: "année", value: ["month", "day", "dayOfWeek", "hour", "minute"] }
];

export const cron_locale_fr = {
	eachPeriod: {
		minuteField: {
			prefix: ":",
			empty: "chaque minute",
			value: "{{value.text}}",
			range: "{{start.text}}-{{end.text}}",
			everyX: "toutes les {{every.value}} minute(s)",
			everyAt: "toutes les {{every.value}} minute(s), à partir de {{at.value}} minute(s)"
		},
		hourField: {
			prefix: "à",
			empty: "chaque heure",
			value: "{{value.text}}",
			range: "{{start.text}}-{{end.text}}",
			everyX: "toutes les {{every.value}} heure(s)",
			everyAt: "toutes les {{every.value}} heure(s), à partir de {{at.value}} heure(s)"
		},
		monthField: {
			prefix: "en",
			empty: "chaque mois",
			value: "{{value.alt}}",
			range: "de {{start.alt}} à {{end.alt}}",
			everyX: "tous les {{every.value}} mois",
			everyAt: "tous les {{every.value}} mois, à partir de {{at.alt}}"
		},
		dayField: {
			prefix: "le",
			empty: "chaque jour du mois",
			value: "{{value.text}}",
			range: "du {{start.text}} au {{end.text}}",
			everyX: "tous les {{every.value}} jour(s)",
			everyAt: "tous les {{every.value}} jour(s), à partir du {{at.alt}} du mois"
		},
		dayOfWeekField: {
			prefix: "le",
			empty: "chaque jour de la semaine",
			value: "{{value.alt}}",
			range: "de {{start.alt}} à {{end.alt}}",
			everyX: "tous les {{every.value}} jour(s) de la semaine",
			everyAt: "tous les {{every.value}} jour(s) de la semaine, à partir de {{at.alt}}"
		}
	},
	hourPeriod: {
		minuteField: {
			prefix: "à"
		}
	},
	monthPeriod: {
		dayOfWeekField: {
			prefix: "et"
		}
	},
	yearPeriod: {
		dayOfWeekField: {
			prefix: "et"
		}
	},
	periodPrefix: "Chaque",
	periodSuffix: ""
};
